module.exports = __webpack_public_path__ + "img/img_throw_4@2x_v2.7e3c1644.png";